import { ApiResource } from '@/core/models/api-resource.interface';
import { JobfunctionCategory } from './job-function-category.interface';

export class JobFunctionCategoryService {
   async getJobFunctionCategories() {
      const response = await http.get<ApiResource<Array<JobfunctionCategory>>>('/job-function-categories');
      return response.data;
   }

   async getJobFunctionCategory() {
      throw Error('Method not implemented');
   }

   async postJobFunctionCategory() {
      throw Error('Method not implemented');
   }

   async putJobFunctionCategory() {
      throw Error('Method not implemented');
   }

   async deleteJobFunctionCategory() {
      throw Error('Method not implemented');
   }
}
